export enum CarStatus {
  open = "OPEN",
  closed = "CLOSED",
}
